<template>
  <div class="confirmation">
    <div class="confirmation__container">
      <div class="confirmation__header">
        <div class="confirmation__check-icon">
          <FontAwesomeIcon :icon="['far', 'check-circle']" />
        </div>

        <template v-if="alreadyConfirmed">
          <h2 class="confirmation__title">
            {{
              $t(
                'landingpage.checkout-page.ticket_guest_registration.already_confirmed.title',
              )
            }}
          </h2>
          <p class="confirmation__intro">
            {{
              $t(
                'landingpage.checkout-page.ticket_guest_registration.already_confirmed.message',
              )
            }}
          </p>
        </template>

        <template v-else>
          <h2 class="confirmation__title">
            {{
              $t(
                'landingpage.checkout-page.ticket_guest_registration.confirmation.title',
              )
            }}
          </h2>
          <p class="confirmation__intro">
            {{
              $t(
                'landingpage.checkout-page.ticket_guest_registration.confirmation.message',
              )
            }}
          </p>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  alreadyConfirmed: { type: Boolean, default: false },
})
</script>
